import format from 'date-fns/format'

export const getDateForPicker = (date) => {
  return format(date, 'YYYY-MM-DD')
}

export const getDateFromPicker = (dateSting) => {
  return new Date()
}
